const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const APPLE_PRIVATE_RELAY_SUFFIX = '@privaterelay.appleid.com';

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value);
}

export function isApplePrivateRelayEmail(value: string): boolean {
  return value.toLowerCase().endsWith(APPLE_PRIVATE_RELAY_SUFFIX);
}

// Fixed width so the mask never leaks how long the real local part is.
const MASK = '******';

/**
 * Masks the local part of an address for display on a verification step
 * (`sam@example.com` -> `s******@example.com`).
 *
 * Keeps the first character so the user can still recognize which of their
 * addresses the code went to. Anything without a usable local part and domain
 * is returned untouched rather than mangled into something meaningless.
 */
export function maskEmail(value: string): string {
  const separator = value.lastIndexOf('@');
  if (separator < 1 || separator === value.length - 1) {
    return value;
  }

  return `${value[0]}${MASK}${value.slice(separator)}`;
}
